// Chef page URL helpers.
// URL format: /shef-detail/<name-slug>-<id>  e.g. /shef-detail/nazir-foods-123
// Bare /shef-detail/<id> still works — chefIdFromSlug extracts the numeric id.

export const slugify = (text) =>
  (text || "")
    .toString()
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");

export const shefDetailPath = (id, firstName, lastName) => {
  if (!id) return "/shef-detail";
  const slug = slugify(`${firstName || ""} ${lastName || ""}`.trim());
  return `/shef-detail/${slug ? `${slug}-${id}` : id}`;
};

export const chefIdFromSlug = (slug) => {
  const match = (slug || "").toString().match(/(\d+)$/);
  return match ? match[1] : slug;
};
